// ⚠️ INTERRUPTOR DE PRUEBA — NO ES COMPORTAMIENTO DEFINITIVO ⚠️
//
// Pisa las miniaturas de la grilla de poses del modo "Imagen con modelo" con dos imágenes
// de muestra, alternándolas (A, B, A, B…). Es sólo para mirar cómo se ve la pantalla con
// otras fotos: NO toca la tabla `poses` de Supabase, no cambia qué pose se genera ni qué
// se manda al backend. Cada tarjeta sigue siendo la pose que dice ser; lo único falso es
// la foto.
//
// ── CÓMO VOLVER ATRÁS ─────────────────────────────────────────────────────────────────
// Poner `ACTIVAS = false` y listo: la grilla vuelve a las miniaturas reales.
// Para borrarlo del todo: eliminar este archivo, la carpeta
// `public/images/poses-prueba/` y las tres líneas que lo usan en `PosePicker.tsx`
// (marcadas con "PRUEBA").
// ──────────────────────────────────────────────────────────────────────────────────────

/** Prendido = la grilla usa las imágenes de prueba. */
export const POSES_PRUEBA_ACTIVAS = true;

/** Las dos imágenes, en el orden en que se alternan. Viven en `public/`, así que se
 *  sirven por path directo (no pasan por el bucket ni por `CachedImg`). */
export const POSES_PRUEBA_IMAGENES = [
  '/images/poses-prueba/05_walkingforward.jpeg',
  '/images/poses-prueba/10_seated.jpeg',
];

/**
 * Cómo se encaja la foto en la tarjeta.
 *
 * `cover` es lo que usa la grilla de verdad y por eso es el default: muestra la pantalla
 * como es. Pero estas dos imágenes son CUADRADAS y la tarjeta es 9:16, así que el recorte
 * se come arriba y abajo (al muñeco le corta cabeza y pies). `contain` las muestra
 * enteras, con aire a los costados, si lo que se quiere mirar es la imagen y no el
 * encuadre.
 */
export const POSES_PRUEBA_AJUSTE: 'cover' | 'contain' = 'cover';

/** La imagen que le toca a la tarjeta N: alterna entre las dos. */
export const imagenDePosePrueba = (indice: number): string =>
  POSES_PRUEBA_IMAGENES[indice % POSES_PRUEBA_IMAGENES.length];
